import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.ProductInSeason';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class ProductInSeason extends RpcClass{

    /**
     *  @class ProductInSeason
     *  @alias module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason
     *  
     * */
    constructor(){
        super();

        /** @type {LocalDate}  */
        this.DateOfCompletionOfTheOrderForTheReferenceModel = null;
        /** @type {string}  */
        this.EID = null;
        /** @type {string}  */
        this.ERPProductWarehouse = null;
        /** @type {string}  */
        this.HSCode = null;
        /** @type {string}  */
        this.PM = null;
        /** @type {string}  */
        this.SKUNumber = null;
        /** @type {string}  */
        this.VATRate = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {Object}  */
        this.aiInsight = null;
        /** @type {boolean}  */
        this.aiInsightInProgress = null;
        /** @type {string}  */
        this.approvalStatus = null;
        /** @type {string}  */
        this.assemblySystemId = null;
        /** @type {string}  */
        this.assortmentGroupId = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {string}  */
        this.basicOfferId = null;
        /** @type {string}  */
        this.brand = null;
        /** @type {string}  */
        this.capacity = null;
        /** @type {string}  */
        this.capsuleName = null;
        /** @type {string}  */
        this.category = null;
        /** @type {boolean}  */
        this.changeOnlyHeelName = null;
        /** @type {boolean}  */
        this.changeOnlyLeatherName = null;
        /** @type {boolean}  */
        this.changeOnlyShoeHoofName = null;
        /** @type {string}  */
        this.clientId = null;
        /** @type {string}  */
        this.cnCodeId = null;
        /** @type {string}  */
        this.collection = null;
        /** @type {string}  */
        this.collectionDirector = null;
        /** @type {boolean}  */
        this.colorBox = null;
        /** @type {string}  */
        this.colorId = null;
        /** @type {string}  */
        this.commissionId = null;
        /** @type {string}  */
        this.commodityGroupId = null;
        /** @type {string}  */
        this.compositionId = null;
        /** @type {boolean}  */
        this.continuation = null;
        /** @type {string}  */
        this.countryOfOrigin = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {LocalDate}  */
        this.dateOfDeliveryOfTheReferenceModel = null;
        /** @type {LocalDate}  */
        this.dateOfTransferOfTheOrder = null;
        /** @type {string}  */
        this.departmentId = null;
        /** @type {string}  */
        this.description = null;
        /** @type {string}  */
        this.designer = null;
        /** @type {string}  */
        this.designerProjectStatus = null;
        /** @type {string}  */
        this.detailsName = null;
        /** @type {string}  */
        this.dimensionId = null;
        /** @type {LocalDate}  */
        this.endDateDesigner = null;
        /** @type {LocalDate}  */
        this.endDateGraphicDesigner = null;
        /** @type {LocalDate}  */
        this.endDateTechnologist = null;
        /** @type {string}  */
        this.englishName = null;
        /** @type {string}  */
        this.fabricCodeCoupon = null;
        /** @type {string}  */
        this.fabricSupplier = null;
        /** @type {string}  */
        this.formNumberId = null;
        /** @type {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}  */
        this.gallery = null;
        /** @type {string}  */
        this.graphicDesigner = null;
        /** @type {string}  */
        this.graphicDesignerProjectStatus = null;
        /** @type {string}  */
        this.heelColor = null;
        /** @type {string}  */
        this.heelName = null;
        /** @type {string}  */
        this.heelProducer = null;
        /** @type {string}  */
        this.heelTypeId = null;
        /** @type {string}  */
        this.id = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.initialPrice = null;
        /** @type {boolean}  */
        this.isATargetDesign = null;
        /** @type {string}  */
        this.leatherColor = null;
        /** @type {string}  */
        this.leatherId = null;
        /** @type {string}  */
        this.leatherName = null;
        /** @type {string}  */
        this.leatherProducer = null;
        /** @type {string}  */
        this.line = null;
        /** @type {string}  */
        this.lineId = null;
        /** @type {string}  */
        this.mainGroupId = null;
        /** @type {string}  */
        this.marketingName = null;
        /** @type {module:src/server/com/silkplm/model/plm/ApplicationUserOnProductInSeasonEmbedded.ApplicationUserOnProductInSeasonEmbedded[]}  */
        this.merchants = null;
        /** @type {boolean}  */
        this.multicolor = null;
        /** @type {string}  */
        this.name = null;
        /** @type {string}  */
        this.nameTransferredToIntrastatDeclarationId = null;
        /** @type {string}  */
        this.nextSeasonCollectionId = null;
        /** @type {string}  */
        this.nextSeasonTypeOfOfferId = null;
        /** @type {string}  */
        this.notes = null;
        /** @type {string}  */
        this.notesRelatedToFirstPPSample = null;
        /** @type {number}  */
        this.numberOfProduct = null;
        /** @type {string}  */
        this.orderNumber = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.outletPrice = null;
        /** @type {string}  */
        this.path = null;
        /** @type {string}  */
        this.pattern = null;
        /** @type {string}  */
        this.patternShoes = null;
        /** @type {module:src/server/com/silkplm/model/plm/DeliveryDateStore.DeliveryDateStore[]}  */
        this.plannedDeliveryDateStores = null;
        /** @type {string}  */
        this.preferredConstructor = null;
        /** @type {string}  */
        this.preferredDesigner = null;
        /** @type {boolean}  */
        this.print = null;
        /** @type {boolean}  */
        this.processing = null;
        /** @type {module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]}  */
        this.productCategoryAttributes = null;
        /** @type {string}  */
        this.productFeatures = null;
        /** @type {string}  */
        this.productId = null;
        /** @type {string}  */
        this.productType = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.promotionalPrice = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {string}  */
        this.relatedModels = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.retailPrice = null;
        /** @type {string}  */
        this.salesCategory = null;
        /** @type {string}  */
        this.salesChannelId = null;
        /** @type {string}  */
        this.sampleNo = null;
        /** @type {string}  */
        this.samplePolandId = null;
        /** @type {string}  */
        this.sampleStatusId = null;
        /** @type {string}  */
        this.seasonId = null;
        /** @type {string}  */
        this.seasonalityId = null;
        /** @type {boolean}  */
        this.selectedForCollection = null;
        /** @type {string}  */
        this.sessionId = null;
        /** @type {string}  */
        this.shoeHoofName = null;
        /** @type {string}  */
        this.shoeHoofProducer = null;
        /** @type {string}  */
        this.shoeSoleName = null;
        /** @type {string}  */
        this.shoeStiffness = null;
        /** @type {string}  */
        this.shortcutModel = null;
        /** @type {boolean}  */
        this.shouldUpgradeOrderNumberSequence = null;
        /** @type {boolean}  */
        this.shouldUpgradeSKUSequence = null;
        /** @type {string}  */
        this.sizeGroupId = null;
        /** @type {string}  */
        this.sizeRange = null;
        /** @type {boolean}  */
        this.sizesConfirmed = null;
        /** @type {string}  */
        this.smallAndLargeSizesId = null;
        /** @type {string}  */
        this.stateOfPrestaShopIntegration = null;
        /** @type {string}  */
        this.styleCut = null;
        /** @type {string}  */
        this.subSeasonId = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.suggestedPrice = null;
        /** @type {string}  */
        this.supplierFinalOffer = null;
        /** @type {string}  */
        this.supplierId = null;
        /** @type {string}  */
        this.supplierProductId = null;
        /** @type {string}  */
        this.technologicalComponents = null;
        /** @type {string}  */
        this.technologistConstructor = null;
        /** @type {string}  */
        this.technologistProjectStatus = null;
        /** @type {string}  */
        this.typeOfBoxId = null;
        /** @type {string}  */
        this.typeOfFootwearId = null;
        /** @type {string}  */
        this.typeOfNumberingId = null;
        /** @type {string}  */
        this.typeOfOfferId = null;
        /** @type {string}  */
        this.typeOfSoleId = null;
        /** @type {string}  */
        this.typeUpperWidth = null;
        /** @type {string}  */
        this.unit = null;
        /** @type {BigDecimal}  */
        this.upperCircumference = null;
        /** @type {BigDecimal}  */
        this.upperHeight = null;
        /** @type {string}  */
        this.uuid = null;
        /** @type {number}  */
        this.version = null;
        /** @type {string}  */
        this.warmingId = null;
        /** @type {string}  */
        this.weight = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }



    /**
     * Get extension tab: ProductWCLElements
     * @returns {Promise<ProductWCLElements>}
     */

    async getProductWCLElements(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "productInSeasonId",
            "com.silkplm.model.plm.ProductWCLElements");
   }
    /**
     * Get extension tab: Technological Details Wash And Maintenance
     * @returns {Promise<TechnologicalDetailsWashAndMaintenance>}
     */

    async getTechnologicalDetailsWashAndMaintenance(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "productInSeasonId",
            "com.silkplm.model.plm.TechnologicalDetailsWashAndMaintenance");
   }
    /**
     * Get extension tab: Dimensions
     * @returns {Promise<Dimensions>}
     */

    async getDimensions(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "productInSeasonId",
            "com.silkplm.model.plm.Dimensions");
   }
    /**
     * Get extension tab: Calculations
     * @returns {Promise<Calculation>}
     */

    async getCalculation(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "productInSeasonId",
            "com.silkplm.model.plm.Calculation");
   }
    /**
     * Get extension tab: Other Cost Calculation
     * @returns {Promise<OtherCostCalculation>}
     */

    async getOtherCostCalculation(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "productInSeasonId",
            "com.silkplm.model.plm.OtherCostCalculation");
   }
    /**
     * Get extension tab: Marketing
     * @returns {Promise<Marketing>}
     */

    async getMarketing(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "productInSeasonId",
            "com.silkplm.model.plm.Marketing");
   }

    /**
     * Get list of detail Technological
     * @returns {Promise<TechnologicalDetails[]>}
     */

    async listTechnologicalDetails(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.dictionaries.TechnologicalDetails",
        "productInSeasonId");
    }
    /**
     * Get list of detail Accessory Technological
     * @returns {Promise<AccessoryTechnological[]>}
     */

    async listAccessoryTechnological(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.dictionaries.AccessoryTechnological",
        "productInSeasonId");
    }
    /**
     * Get list of detail Method Of Execution Technological
     * @returns {Promise<MethodOfExecutionTechnological[]>}
     */

    async listMethodOfExecutionTechnological(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.dictionaries.MethodOfExecutionTechnological",
        "productInSeasonId");
    }
    /**
     * Get list of detail Size In Product In Season
     * @returns {Promise<SizeInProductInSeason[]>}
     */

    async listSizeInProductInSeason(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.SizeInProductInSeason",
        "productInSeasonId");
    }
    /**
     * Get list of detail Dimensions Rows
     * @returns {Promise<DimensionsRows[]>}
     */

    async listDimensionsRows(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.DimensionsRows",
        "productInSeasonId");
    }
    /**
     * Get list of detail pp-sample
     * @returns {Promise<PPSamplesProduct[]>}
     */

    async listPPSamplesProduct(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.PPSamplesProduct",
        "productSeasonId");
    }
    /**
     * Get list of detail Shipment Sample
     * @returns {Promise<ShipmentSample[]>}
     */

    async listShipmentSample(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ShipmentSample",
        "productSeasonId");
    }
    /**
     * Get list of detail Packaging Product
     * @returns {Promise<PackagingProduct[]>}
     */

    async listPackagingProduct(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.PackagingProduct",
        "productSeasonId");
    }
    /**
     * Get list of detail Application User On Product In Season
     * @returns {Promise<ApplicationUserOnProductInSeason[]>}
     */

    async listApplicationUserOnProductInSeason(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ApplicationUserOnProductInSeason",
        "productInSeasonId");
    }
    /**
     * Get list of detail WCLProduct
     * @returns {Promise<WCLProduct[]>}
     */

    async listWCLProduct(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.WCLProduct",
        "productSeasonId");
    }
    /**
     * Get list of detail Basic Cost Calculation
     * @returns {Promise<BasicCostCalculation[]>}
     */

    async listBasicCostCalculation(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.BasicCostCalculation",
        "productInSeasonId");
    }
    /**
     * Get list of detail Additional Cost Calculation
     * @returns {Promise<AdditionalCostCalculation[]>}
     */

    async listAdditionalCostCalculation(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.AdditionalCostCalculation",
        "productInSeasonId");
    }
    /**
     * Get list of detail Branding Calculation
     * @returns {Promise<BrandingCalculation[]>}
     */

    async listBrandingCalculation(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.BrandingCalculation",
        "productInSeasonId");
    }
    /**
     * Get list of detail Planning Product
     * @returns {Promise<PlanningProduct[]>}
     */

    async listPlanningProduct(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.PlanningProduct",
        "productSeasonId");
    }
    /**
     * Get list of detail Required Test Report
     * @returns {Promise<RequiredTestReport[]>}
     */

    async listRequiredTestReport(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.RequiredTestReport",
        "productSeasonId");
    }
    /**
     * Get list of detail Color For Product In Season
     * @returns {Promise<ColorForProductInSeason[]>}
     */

    async listColorForProductInSeason(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ColorForProductInSeason",
        "productInSeason");
    }
    /**
     * Get list of detail Shipment Status With Quantity
     * @returns {Promise<ShipmentStatusWithQuantity[]>}
     */

    async listShipmentStatusWithQuantity(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ShipmentStatusWithQuantity",
        "productSeasonId");
    }
    /**
     * Get list of detail Size For Product In Season
     * @returns {Promise<SizeForProductInSeason[]>}
     */

    async listSizeForProductInSeason(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.SizeForProductInSeason",
        "productInSeasonId");
    }
    /**
     * Get list of detail Model Component
     * @returns {Promise<ModelComponent[]>}
     */

    async listModelComponent(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ModelComponent",
        "productInSeasonId");
    }
    /**
     * Get list of detail Color Version
     * @returns {Promise<ColorVersion[]>}
     */

    async listColorVersion(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ColorVersion",
        "productInSeasonId");
    }
    /**
     * Get list of detail Marketing Similar Products
     * @returns {Promise<MarketingSimilarProducts[]>}
     */

    async listMarketingSimilarProducts(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.matching.MarketingSimilarProducts",
        "productInSeasonId");
    }
    /**
     * Get list of detail Marketing Matched Products
     * @returns {Promise<MarketingMatchedProducts[]>}
     */

    async listMarketingMatchedProducts(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.matching.MarketingMatchedProducts",
        "productInSeasonId");
    }

    /** @type {LocalDate}  */
    get lineDeadlineForDeliveryOfFabric(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['lineDeadlineForDeliveryOfFabric'] : null, this.__metadata__['lineDeadlineForDeliveryOfFabric']?.remoteType);
    }
    set lineDeadlineForDeliveryOfFabric(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get lineDeadlineForDeliveryToWarehouse(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['lineDeadlineForDeliveryToWarehouse'] : null, this.__metadata__['lineDeadlineForDeliveryToWarehouse']?.remoteType);
    }
    set lineDeadlineForDeliveryToWarehouse(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get lineDeadlineForDispatch(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['lineDeadlineForDispatch'] : null, this.__metadata__['lineDeadlineForDispatch']?.remoteType);
    }
    set lineDeadlineForDispatch(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get lineDeadlineForFabricOrder(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['lineDeadlineForFabricOrder'] : null, this.__metadata__['lineDeadlineForFabricOrder']?.remoteType);
    }
    set lineDeadlineForFabricOrder(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get lineDeadlineForPrototype(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['lineDeadlineForPrototype'] : null, this.__metadata__['lineDeadlineForPrototype']?.remoteType);
    }
    set lineDeadlineForPrototype(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get lineDeadlineForTheContractOfTheFinishedProduct(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['lineDeadlineForTheContractOfTheFinishedProduct'] : null, this.__metadata__['lineDeadlineForTheContractOfTheFinishedProduct']?.remoteType);
    }
    set lineDeadlineForTheContractOfTheFinishedProduct(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get lineDeadlineOfEntryOfEntireLineIntoShops(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['lineDeadlineOfEntryOfEntireLineIntoShops'] : null, this.__metadata__['lineDeadlineOfEntryOfEntireLineIntoShops']?.remoteType);
    }
    set lineDeadlineOfEntryOfEntireLineIntoShops(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get lineDesignDeadline(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['lineDesignDeadline'] : null, this.__metadata__['lineDesignDeadline']?.remoteType);
    }
    set lineDesignDeadline(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get seasonIdFirstReleaseDate(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['seasonIdFirstReleaseDate'] : null, this.__metadata__['seasonIdFirstReleaseDate']?.remoteType);
    }
    set seasonIdFirstReleaseDate(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get linePlanDeadline(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['linePlanDeadline'] : null, this.__metadata__['linePlanDeadline']?.remoteType);
    }
    set linePlanDeadline(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get seasonIdReleaseDate(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['seasonIdReleaseDate'] : null, this.__metadata__['seasonIdReleaseDate']?.remoteType);
    }
    set seasonIdReleaseDate(val){
    }
    // fk: false

    /** @type {string}  */
    get fabricSupplierSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['fabricSupplierSupplierCode'] : null, this.__metadata__['fabricSupplierSupplierCode']?.remoteType);
    }
    set fabricSupplierSupplierCode(val){
    }
    // fk: false

    /** @type {string}  */
    get supplierFinalOfferSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierFinalOfferSupplierCode'] : null, this.__metadata__['supplierFinalOfferSupplierCode']?.remoteType);
    }
    set supplierFinalOfferSupplierCode(val){
    }
    // fk: false

    /** @type {string}  */
    get supplierIdSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdSupplierCode'] : null, this.__metadata__['supplierIdSupplierCode']?.remoteType);
    }
    set supplierIdSupplierCode(val){
    }
    // fk: false

    /** @type {boolean}  */
    get approvalToCollection(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['approvalToCollection'] : null, this.__metadata__['approvalToCollection']?.remoteType);
    }
    set approvalToCollection(val){
    }


    /** @type {boolean}  */
    get calculateShortcutModels(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['calculateShortcutModels'] : null, this.__metadata__['calculateShortcutModels']?.remoteType);
    }
    set calculateShortcutModels(val){
    }


    /** @type {string}  */
    get colorWarning(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['colorWarning'] : null, this.__metadata__['colorWarning']?.remoteType);
    }
    set colorWarning(val){
    }


    /** @type {number}  */
    get computeDesignerProjectStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computeDesignerProjectStatus'] : null, this.__metadata__['computeDesignerProjectStatus']?.remoteType);
    }
    set computeDesignerProjectStatus(val){
    }

    /** @returns {Promise<String>} */
    getComputeDesignerProjectStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computeDesignerProjectStatus', allowRemote); //  true 
    }

    /** @returns {String} */
    getComputeDesignerProjectStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computeDesignerProjectStatus'); //  true 
    }

    /** @returns {Promise<TransportType>} */
    getComputeDesignerProjectStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'computeDesignerProjectStatus',  allowRemote); //  true 
    }

    /** @type {number}  */
    get computeGraphicDesignerProjectStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computeGraphicDesignerProjectStatus'] : null, this.__metadata__['computeGraphicDesignerProjectStatus']?.remoteType);
    }
    set computeGraphicDesignerProjectStatus(val){
    }

    /** @returns {Promise<String>} */
    getComputeGraphicDesignerProjectStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computeGraphicDesignerProjectStatus', allowRemote); //  true 
    }

    /** @returns {String} */
    getComputeGraphicDesignerProjectStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computeGraphicDesignerProjectStatus'); //  true 
    }

    /** @returns {Promise<TransportType>} */
    getComputeGraphicDesignerProjectStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'computeGraphicDesignerProjectStatus',  allowRemote); //  true 
    }

    /** @type {number}  */
    get computeTechnologistProjectStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computeTechnologistProjectStatus'] : null, this.__metadata__['computeTechnologistProjectStatus']?.remoteType);
    }
    set computeTechnologistProjectStatus(val){
    }

    /** @returns {Promise<String>} */
    getComputeTechnologistProjectStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computeTechnologistProjectStatus', allowRemote); //  true 
    }

    /** @returns {String} */
    getComputeTechnologistProjectStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computeTechnologistProjectStatus'); //  true 
    }

    /** @returns {Promise<TransportType>} */
    getComputeTechnologistProjectStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'computeTechnologistProjectStatus',  allowRemote); //  true 
    }

    /** @type {string}  */
    get computedFullName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedFullName'] : null, this.__metadata__['computedFullName']?.remoteType);
    }
    set computedFullName(val){
    }


    /** @type {number}  */
    get computedProductType(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedProductType'] : null, this.__metadata__['computedProductType']?.remoteType);
    }
    set computedProductType(val){
    }

    /** @returns {Promise<String>} */
    getComputedProductTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computedProductType', allowRemote); //  true 
    }

    /** @returns {String} */
    getComputedProductTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computedProductType'); //  true 
    }

    /** @returns {Promise<TransportType>} */
    getComputedProductTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'computedProductType',  allowRemote); //  true 
    }

    /** @type {number}  */
    get computedVATFromCalculation(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedVATFromCalculation'] : null, this.__metadata__['computedVATFromCalculation']?.remoteType);
    }
    set computedVATFromCalculation(val){
    }

    /** @returns {Promise<String>} */
    getComputedVATFromCalculationLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computedVATFromCalculation', allowRemote); //  true 
    }

    /** @returns {String} */
    getComputedVATFromCalculationStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computedVATFromCalculation'); //  true 
    }

    /** @returns {Promise<TransportType>} */
    getComputedVATFromCalculationEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'computedVATFromCalculation',  allowRemote); //  true 
    }

    /** @type {number}  */
    get countryOfOriginFinalOffer(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['countryOfOriginFinalOffer'] : null, this.__metadata__['countryOfOriginFinalOffer']?.remoteType);
    }
    set countryOfOriginFinalOffer(val){
    }

    /** @returns {Promise<String>} */
    getCountryOfOriginFinalOfferLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'countryOfOriginFinalOffer', allowRemote); //  true 
    }

    /** @returns {String} */
    getCountryOfOriginFinalOfferStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'countryOfOriginFinalOffer'); //  true 
    }

    /** @returns {Promise<Country>} */
    getCountryOfOriginFinalOfferEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'countryOfOriginFinalOffer',  allowRemote); //  true 
    }

    /** @type {string}  */
    get defaultEAN(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['defaultEAN'] : null, this.__metadata__['defaultEAN']?.remoteType);
    }
    set defaultEAN(val){
    }


    /** @type {boolean}  */
    get eAN(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['eAN'] : null, this.__metadata__['eAN']?.remoteType);
    }
    set eAN(val){
    }


    /** @type {string}  */
    get finalDecision(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['finalDecision'] : null, this.__metadata__['finalDecision']?.remoteType);
    }
    set finalDecision(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get finalPurchasingPriceFinalOffer(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['finalPurchasingPriceFinalOffer'] : null, this.__metadata__['finalPurchasingPriceFinalOffer']?.remoteType);
    }
    set finalPurchasingPriceFinalOffer(val){
    }


    /** @type {BigDecimal}  */
    get firstMargin(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['firstMargin'] : null, this.__metadata__['firstMargin']?.remoteType);
    }
    set firstMargin(val){
    }


    /** @type {string}  */
    get fullName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['fullName'] : null, this.__metadata__['fullName']?.remoteType);
    }
    set fullName(val){
    }


    /** @type {BigDecimal}  */
    get margin(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['margin'] : null, this.__metadata__['margin']?.remoteType);
    }
    set margin(val){
    }


    /** @type {BigDecimal}  */
    get marginFinalOffer(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['marginFinalOffer'] : null, this.__metadata__['marginFinalOffer']?.remoteType);
    }
    set marginFinalOffer(val){
    }


    /** @type {string}  */
    get merchantsComputed(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['merchantsComputed'] : null, this.__metadata__['merchantsComputed']?.remoteType);
    }
    set merchantsComputed(val){
    }


    /** @type {number}  */
    get minQuantityFinalOffer(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['minQuantityFinalOffer'] : null, this.__metadata__['minQuantityFinalOffer']?.remoteType);
    }
    set minQuantityFinalOffer(val){
    }


    /** @type {string}  */
    get nameFromERP(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['nameFromERP'] : null, this.__metadata__['nameFromERP']?.remoteType);
    }
    set nameFromERP(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get netPrice(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['netPrice'] : null, this.__metadata__['netPrice']?.remoteType);
    }
    set netPrice(val){
    }


    /** @type {number}  */
    get port(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['port'] : null, this.__metadata__['port']?.remoteType);
    }
    set port(val){
    }

    /** @returns {Promise<String>} */
    getPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'port', allowRemote); //  true 
    }

    /** @returns {String} */
    getPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'port'); //  true 
    }

    /** @returns {Promise<Port>} */
    getPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'port',  allowRemote); //  true 
    }

    /** @type {number}  */
    get priceGroup(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['priceGroup'] : null, this.__metadata__['priceGroup']?.remoteType);
    }
    set priceGroup(val){
    }


    /** @type {LocalDate}  */
    get productInStores(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productInStores'] : null, this.__metadata__['productInStores']?.remoteType);
    }
    set productInStores(val){
    }


    /** @type {number}  */
    get productInStoresMonth(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productInStoresMonth'] : null, this.__metadata__['productInStoresMonth']?.remoteType);
    }
    set productInStoresMonth(val){
    }


    /** @type {LocalDate}  */
    get productInWarehouse(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productInWarehouse'] : null, this.__metadata__['productInWarehouse']?.remoteType);
    }
    set productInWarehouse(val){
    }


    /** @type {number}  */
    get productInWarehouseWeek(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productInWarehouseWeek'] : null, this.__metadata__['productInWarehouseWeek']?.remoteType);
    }
    set productInWarehouseWeek(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get productionCostFinalOffer(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productionCostFinalOffer'] : null, this.__metadata__['productionCostFinalOffer']?.remoteType);
    }
    set productionCostFinalOffer(val){
    }


    /** @type {string}  */
    get seasonWarning(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['seasonWarning'] : null, this.__metadata__['seasonWarning']?.remoteType);
    }
    set seasonWarning(val){
    }


    /** @type {BigDecimal}  */
    get stockLevels(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['stockLevels'] : null, this.__metadata__['stockLevels']?.remoteType);
    }
    set stockLevels(val){
    }


    /** @type {*[]}  */
    get targetPlanningProduct(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['targetPlanningProduct'] : null, this.__metadata__['targetPlanningProduct']?.remoteType);
    }
    set targetPlanningProduct(val){
    }


    /** @type {LocalDate}  */
    get todayDate(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['todayDate'] : null, this.__metadata__['todayDate']?.remoteType);
    }
    set todayDate(val){
    }


    /** @type {string}  */
    get typeOrKind(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['typeOrKind'] : null, this.__metadata__['typeOrKind']?.remoteType);
    }
    set typeOrKind(val){
    }


    /** @type {string}  */
    get whatsNext(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['whatsNext'] : null, this.__metadata__['whatsNext']?.remoteType);
    }
    set whatsNext(val){
    }


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withDateOfCompletionOfTheOrderForTheReferenceModel(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.DateOfCompletionOfTheOrderForTheReferenceModel = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withERPProductWarehouse(val){
        this.ERPProductWarehouse = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getERPProductWarehouseLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ERPProductWarehouse', 'ERPProductWarehouse', allowRemote); //  true 
    }

    /** @returns {String} */
        getERPProductWarehouseStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ERPProductWarehouse', 'ERPProductWarehouse'); //  true 
    }

        /** @returns {Promise<ERPProductWarehouse>} */
    getERPProductWarehouseEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ERPProductWarehouse', 'ERPProductWarehouse', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withHSCode(val){
        this.HSCode = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withPM(val){
        this.PM = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPMLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'PM', allowRemote); //  true 
    }

    /** @returns {String} */
        getPMStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'PM'); //  true 
    }

        /** @returns {Promise<ApplicationUser>} */
    getPMEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'PM', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSKUNumber(val){
        this.SKUNumber = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withVATRate(val){
        this.VATRate = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getVATRateLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.VatLevel', 'VATRate', allowRemote); //  true 
    }

    /** @returns {String} */
        getVATRateStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.VatLevel', 'VATRate'); //  true 
    }

        /** @returns {Promise<VatLevel>} */
    getVATRateEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.VatLevel', 'VATRate', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {Object}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withAiInsight(val){
        let rawValue = val;
        let v = val;
        v = rawValue
        this.aiInsight = v;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withAiInsightInProgress(val){
        this.aiInsightInProgress = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withApprovalStatus(val){
        this.approvalStatus = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getApprovalStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ApprovalStatus', 'approvalStatus', allowRemote); //  true 
    }

    /** @returns {String} */
        getApprovalStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ApprovalStatus', 'approvalStatus'); //  true 
    }

        /** @returns {Promise<ApprovalStatus>} */
    getApprovalStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ApprovalStatus', 'approvalStatus', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withAssemblySystemId(val){
        this.assemblySystemId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getAssemblySystemIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.AssemblySystem', 'assemblySystemId', allowRemote); //  true 
    }

    /** @returns {String} */
        getAssemblySystemIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.AssemblySystem', 'assemblySystemId'); //  true 
    }

        /** @returns {Promise<AssemblySystem>} */
    getAssemblySystemIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.AssemblySystem', 'assemblySystemId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withAssortmentGroupId(val){
        this.assortmentGroupId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getAssortmentGroupIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.AssortmentGroup', 'assortmentGroupId', allowRemote); //  true 
    }

    /** @returns {String} */
        getAssortmentGroupIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.AssortmentGroup', 'assortmentGroupId'); //  true 
    }

        /** @returns {Promise<AssortmentGroup>} */
    getAssortmentGroupIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.AssortmentGroup', 'assortmentGroupId', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withBasicOfferId(val){
        this.basicOfferId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getBasicOfferIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.BasicOffer', 'basicOfferId', allowRemote); //  true 
    }

    /** @returns {String} */
        getBasicOfferIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.BasicOffer', 'basicOfferId'); //  true 
    }

        /** @returns {Promise<BasicOffer>} */
    getBasicOfferIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.BasicOffer', 'basicOfferId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withBrand(val){
        this.brand = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getBrandLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Brand', 'brand', allowRemote); //  true 
    }

    /** @returns {String} */
        getBrandStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Brand', 'brand'); //  true 
    }

        /** @returns {Promise<Brand>} */
    getBrandEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Brand', 'brand', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCapacity(val){
        this.capacity = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCapsuleName(val){
        this.capsuleName = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCapsuleNameLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Capsule', 'capsuleName', allowRemote); //  true 
    }

    /** @returns {String} */
        getCapsuleNameStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Capsule', 'capsuleName'); //  true 
    }

        /** @returns {Promise<Capsule>} */
    getCapsuleNameEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Capsule', 'capsuleName', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCategory(val){
        this.category = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Category', 'category', allowRemote); //  true 
    }

    /** @returns {String} */
        getCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Category', 'category'); //  true 
    }

        /** @returns {Promise<Category>} */
    getCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Category', 'category', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withChangeOnlyHeelName(val){
        this.changeOnlyHeelName = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withChangeOnlyLeatherName(val){
        this.changeOnlyLeatherName = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withChangeOnlyShoeHoofName(val){
        this.changeOnlyShoeHoofName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withClientId(val){
        this.clientId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getClientIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Client', 'clientId', allowRemote); //  true 
    }

    /** @returns {String} */
        getClientIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Client', 'clientId'); //  true 
    }

        /** @returns {Promise<Client>} */
    getClientIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Client', 'clientId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCnCodeId(val){
        this.cnCodeId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCnCodeIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.CNCode', 'cnCodeId', allowRemote); //  true 
    }

    /** @returns {String} */
        getCnCodeIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.CNCode', 'cnCodeId'); //  true 
    }

        /** @returns {Promise<CNCode>} */
    getCnCodeIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.CNCode', 'cnCodeId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCollection(val){
        this.collection = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCollectionLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Collection', 'collection', allowRemote); //  true 
    }

    /** @returns {String} */
        getCollectionStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Collection', 'collection'); //  true 
    }

        /** @returns {Promise<Collection>} */
    getCollectionEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Collection', 'collection', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCollectionDirector(val){
        this.collectionDirector = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCollectionDirectorLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'collectionDirector', allowRemote); //  true 
    }

    /** @returns {String} */
        getCollectionDirectorStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'collectionDirector'); //  true 
    }

        /** @returns {Promise<ApplicationUser>} */
    getCollectionDirectorEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'collectionDirector', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withColorBox(val){
        this.colorBox = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withColorId(val){
        this.colorId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getColorIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Colors', 'colorId', allowRemote); //  true 
    }

    /** @returns {String} */
        getColorIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Colors', 'colorId'); //  true 
    }

        /** @returns {Promise<Colors>} */
    getColorIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Colors', 'colorId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCommissionId(val){
        this.commissionId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCommissionIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Commission', 'commissionId', allowRemote); //  true 
    }

    /** @returns {String} */
        getCommissionIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Commission', 'commissionId'); //  true 
    }

        /** @returns {Promise<Commission>} */
    getCommissionIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Commission', 'commissionId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCommodityGroupId(val){
        this.commodityGroupId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCommodityGroupIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.CommodityGroup', 'commodityGroupId', allowRemote); //  true 
    }

    /** @returns {String} */
        getCommodityGroupIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.CommodityGroup', 'commodityGroupId'); //  true 
    }

        /** @returns {Promise<CommodityGroup>} */
    getCommodityGroupIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.CommodityGroup', 'commodityGroupId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCompositionId(val){
        this.compositionId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCompositionIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Materials', 'compositionId', allowRemote); //  true 
    }

    /** @returns {String} */
        getCompositionIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Materials', 'compositionId'); //  true 
    }

        /** @returns {Promise<Materials>} */
    getCompositionIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Materials', 'compositionId', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withContinuation(val){
        this.continuation = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCountryOfOrigin(val){
        this.countryOfOrigin = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCountryOfOriginLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'countryOfOrigin', allowRemote); //  true 
    }

    /** @returns {String} */
        getCountryOfOriginStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'countryOfOrigin'); //  true 
    }

        /** @returns {Promise<Country>} */
    getCountryOfOriginEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'countryOfOrigin', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withDateOfDeliveryOfTheReferenceModel(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.dateOfDeliveryOfTheReferenceModel = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withDateOfTransferOfTheOrder(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.dateOfTransferOfTheOrder = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withDepartmentId(val){
        this.departmentId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDepartmentIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DepartmentDictionary', 'departmentId', allowRemote); //  true 
    }

    /** @returns {String} */
        getDepartmentIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DepartmentDictionary', 'departmentId'); //  true 
    }

        /** @returns {Promise<DepartmentDictionary>} */
    getDepartmentIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DepartmentDictionary', 'departmentId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withDescription(val){
        this.description = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withDesigner(val){
        this.designer = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDesignerLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'designer', allowRemote); //  true 
    }

    /** @returns {String} */
        getDesignerStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'designer'); //  true 
    }

        /** @returns {Promise<ApplicationUser>} */
    getDesignerEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'designer', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withDesignerProjectStatus(val){
        this.designerProjectStatus = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDesignerProjectStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DesignerProjectStatus', 'designerProjectStatus', allowRemote); //  true 
    }

    /** @returns {String} */
        getDesignerProjectStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DesignerProjectStatus', 'designerProjectStatus'); //  true 
    }

        /** @returns {Promise<DesignerProjectStatus>} */
    getDesignerProjectStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DesignerProjectStatus', 'designerProjectStatus', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withDetailsName(val){
        this.detailsName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withDimensionId(val){
        this.dimensionId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDimensionIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Dimension', 'dimensionId', allowRemote); //  true 
    }

    /** @returns {String} */
        getDimensionIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Dimension', 'dimensionId'); //  true 
    }

        /** @returns {Promise<Dimension>} */
    getDimensionIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Dimension', 'dimensionId', allowRemote); //  true 
    }

    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withEndDateDesigner(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.endDateDesigner = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withEndDateGraphicDesigner(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.endDateGraphicDesigner = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withEndDateTechnologist(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.endDateTechnologist = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withEnglishName(val){
        this.englishName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withFabricCodeCoupon(val){
        this.fabricCodeCoupon = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withFabricSupplier(val){
        this.fabricSupplier = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getFabricSupplierLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'fabricSupplier', allowRemote); //  true 
    }

    /** @returns {String} */
        getFabricSupplierStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'fabricSupplier'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getFabricSupplierEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'fabricSupplier', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withFormNumberId(val){
        this.formNumberId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getFormNumberIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.FormNumber', 'formNumberId', allowRemote); //  true 
    }

    /** @returns {String} */
        getFormNumberIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.FormNumber', 'formNumberId'); //  true 
    }

        /** @returns {Promise<FormNumber>} */
    getFormNumberIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.FormNumber', 'formNumberId', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withGallery(val){
        this.gallery = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withGraphicDesigner(val){
        this.graphicDesigner = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getGraphicDesignerLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'graphicDesigner', allowRemote); //  true 
    }

    /** @returns {String} */
        getGraphicDesignerStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'graphicDesigner'); //  true 
    }

        /** @returns {Promise<ApplicationUser>} */
    getGraphicDesignerEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'graphicDesigner', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withGraphicDesignerProjectStatus(val){
        this.graphicDesignerProjectStatus = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getGraphicDesignerProjectStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.GraphicDesignerProjectStatus', 'graphicDesignerProjectStatus', allowRemote); //  true 
    }

    /** @returns {String} */
        getGraphicDesignerProjectStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.GraphicDesignerProjectStatus', 'graphicDesignerProjectStatus'); //  true 
    }

        /** @returns {Promise<GraphicDesignerProjectStatus>} */
    getGraphicDesignerProjectStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.GraphicDesignerProjectStatus', 'graphicDesignerProjectStatus', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withHeelColor(val){
        this.heelColor = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getHeelColorLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Colors', 'heelColor', allowRemote); //  true 
    }

    /** @returns {String} */
        getHeelColorStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Colors', 'heelColor'); //  true 
    }

        /** @returns {Promise<Colors>} */
    getHeelColorEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Colors', 'heelColor', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withHeelName(val){
        this.heelName = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getHeelNameLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'heelName', allowRemote); //  true 
    }

    /** @returns {String} */
        getHeelNameStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'heelName'); //  true 
    }

        /** @returns {Promise<ComponentIndex>} */
    getHeelNameEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ComponentIndex', 'heelName', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withHeelProducer(val){
        this.heelProducer = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getHeelProducerLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'heelProducer', allowRemote); //  true 
    }

    /** @returns {String} */
        getHeelProducerStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'heelProducer'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getHeelProducerEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'heelProducer', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withHeelTypeId(val){
        this.heelTypeId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getHeelTypeIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.HeelType', 'heelTypeId', allowRemote); //  true 
    }

    /** @returns {String} */
        getHeelTypeIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.HeelType', 'heelTypeId'); //  true 
    }

        /** @returns {Promise<HeelType>} */
    getHeelTypeIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.HeelType', 'heelTypeId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withInitialPrice(val){
        this.initialPrice = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withIsATargetDesign(val){
        this.isATargetDesign = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withLeatherColor(val){
        this.leatherColor = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getLeatherColorLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Colors', 'leatherColor', allowRemote); //  true 
    }

    /** @returns {String} */
        getLeatherColorStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Colors', 'leatherColor'); //  true 
    }

        /** @returns {Promise<Colors>} */
    getLeatherColorEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Colors', 'leatherColor', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withLeatherId(val){
        this.leatherId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getLeatherIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Leather', 'leatherId', allowRemote); //  true 
    }

    /** @returns {String} */
        getLeatherIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Leather', 'leatherId'); //  true 
    }

        /** @returns {Promise<Leather>} */
    getLeatherIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Leather', 'leatherId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withLeatherName(val){
        this.leatherName = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getLeatherNameLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'leatherName', allowRemote); //  true 
    }

    /** @returns {String} */
        getLeatherNameStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'leatherName'); //  true 
    }

        /** @returns {Promise<ComponentIndex>} */
    getLeatherNameEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ComponentIndex', 'leatherName', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withLeatherProducer(val){
        this.leatherProducer = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getLeatherProducerLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'leatherProducer', allowRemote); //  true 
    }

    /** @returns {String} */
        getLeatherProducerStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'leatherProducer'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getLeatherProducerEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'leatherProducer', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withLine(val){
        this.line = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getLineLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Line', 'line', allowRemote); //  true 
    }

    /** @returns {String} */
        getLineStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Line', 'line'); //  true 
    }

        /** @returns {Promise<Line>} */
    getLineEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Line', 'line', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withLineId(val){
        this.lineId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getLineIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.LineDictionary', 'lineId', allowRemote); //  true 
    }

    /** @returns {String} */
        getLineIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.LineDictionary', 'lineId'); //  true 
    }

        /** @returns {Promise<LineDictionary>} */
    getLineIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.LineDictionary', 'lineId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withMainGroupId(val){
        this.mainGroupId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMainGroupIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.MainGroup', 'mainGroupId', allowRemote); //  true 
    }

    /** @returns {String} */
        getMainGroupIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.MainGroup', 'mainGroupId'); //  true 
    }

        /** @returns {Promise<MainGroup>} */
    getMainGroupIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.MainGroup', 'mainGroupId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withMarketingName(val){
        this.marketingName = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/plm/ApplicationUserOnProductInSeasonEmbedded.ApplicationUserOnProductInSeasonEmbedded[]}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withMerchants(val){
        this.merchants = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withMulticolor(val){
        this.multicolor = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withName(val){
        this.name = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withNameTransferredToIntrastatDeclarationId(val){
        this.nameTransferredToIntrastatDeclarationId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getNameTransferredToIntrastatDeclarationIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.NameTransferredToIntrastatDeclaration', 'nameTransferredToIntrastatDeclarationId', allowRemote); //  true 
    }

    /** @returns {String} */
        getNameTransferredToIntrastatDeclarationIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.NameTransferredToIntrastatDeclaration', 'nameTransferredToIntrastatDeclarationId'); //  true 
    }

        /** @returns {Promise<NameTransferredToIntrastatDeclaration>} */
    getNameTransferredToIntrastatDeclarationIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.NameTransferredToIntrastatDeclaration', 'nameTransferredToIntrastatDeclarationId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withNextSeasonCollectionId(val){
        this.nextSeasonCollectionId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getNextSeasonCollectionIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.NextSeasonCollection', 'nextSeasonCollectionId', allowRemote); //  true 
    }

    /** @returns {String} */
        getNextSeasonCollectionIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.NextSeasonCollection', 'nextSeasonCollectionId'); //  true 
    }

        /** @returns {Promise<NextSeasonCollection>} */
    getNextSeasonCollectionIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.NextSeasonCollection', 'nextSeasonCollectionId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withNextSeasonTypeOfOfferId(val){
        this.nextSeasonTypeOfOfferId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getNextSeasonTypeOfOfferIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.NextSeasonTypeOfOffer', 'nextSeasonTypeOfOfferId', allowRemote); //  true 
    }

    /** @returns {String} */
        getNextSeasonTypeOfOfferIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.NextSeasonTypeOfOffer', 'nextSeasonTypeOfOfferId'); //  true 
    }

        /** @returns {Promise<NextSeasonTypeOfOffer>} */
    getNextSeasonTypeOfOfferIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.NextSeasonTypeOfOffer', 'nextSeasonTypeOfOfferId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withNotes(val){
        this.notes = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withNotesRelatedToFirstPPSample(val){
        this.notesRelatedToFirstPPSample = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withNumberOfProduct(val){
        this.numberOfProduct = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withOrderNumber(val){
        this.orderNumber = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withOutletPrice(val){
        this.outletPrice = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withPath(val){
        this.path = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPathLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Path', 'path', allowRemote); //  true 
    }

    /** @returns {String} */
        getPathStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Path', 'path'); //  true 
    }

        /** @returns {Promise<Path>} */
    getPathEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Path', 'path', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withPattern(val){
        this.pattern = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPatternLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Pattern', 'pattern', allowRemote); //  true 
    }

    /** @returns {String} */
        getPatternStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Pattern', 'pattern'); //  true 
    }

        /** @returns {Promise<Pattern>} */
    getPatternEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Pattern', 'pattern', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withPatternShoes(val){
        this.patternShoes = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/plm/DeliveryDateStore.DeliveryDateStore[]}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withPlannedDeliveryDateStores(val){
        this.plannedDeliveryDateStores = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withPreferredConstructor(val){
        this.preferredConstructor = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPreferredConstructorLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Constructor', 'preferredConstructor', allowRemote); //  true 
    }

    /** @returns {String} */
        getPreferredConstructorStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Constructor', 'preferredConstructor'); //  true 
    }

        /** @returns {Promise<Constructor>} */
    getPreferredConstructorEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Constructor', 'preferredConstructor', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withPreferredDesigner(val){
        this.preferredDesigner = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPreferredDesignerLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Designer', 'preferredDesigner', allowRemote); //  true 
    }

    /** @returns {String} */
        getPreferredDesignerStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Designer', 'preferredDesigner'); //  true 
    }

        /** @returns {Promise<Designer>} */
    getPreferredDesignerEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Designer', 'preferredDesigner', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withPrint(val){
        this.print = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withProcessing(val){
        this.processing = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withProductCategoryAttributes(val){
        this.productCategoryAttributes = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withProductFeatures(val){
        this.productFeatures = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withProductId(val){
        this.productId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getProductIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Product', 'productId', allowRemote); //  true 
    }

    /** @returns {String} */
        getProductIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Product', 'productId'); //  true 
    }

        /** @returns {Promise<Product>} */
    getProductIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Product', 'productId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withProductType(val){
        this.productType = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getProductTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ProductType', 'productType', allowRemote); //  true 
    }

    /** @returns {String} */
        getProductTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ProductType', 'productType'); //  true 
    }

        /** @returns {Promise<ProductType>} */
    getProductTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ProductType', 'productType', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withPromotionalPrice(val){
        this.promotionalPrice = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withRelatedModels(val){
        this.relatedModels = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withRetailPrice(val){
        this.retailPrice = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSalesCategory(val){
        this.salesCategory = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSalesCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SalesCategory', 'salesCategory', allowRemote); //  true 
    }

    /** @returns {String} */
        getSalesCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SalesCategory', 'salesCategory'); //  true 
    }

        /** @returns {Promise<SalesCategory>} */
    getSalesCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SalesCategory', 'salesCategory', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSalesChannelId(val){
        this.salesChannelId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSalesChannelIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SalesChannel', 'salesChannelId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSalesChannelIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SalesChannel', 'salesChannelId'); //  true 
    }

        /** @returns {Promise<SalesChannel>} */
    getSalesChannelIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SalesChannel', 'salesChannelId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSampleNo(val){
        this.sampleNo = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSamplePolandId(val){
        this.samplePolandId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSamplePolandIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SamplePoland', 'samplePolandId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSamplePolandIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SamplePoland', 'samplePolandId'); //  true 
    }

        /** @returns {Promise<SamplePoland>} */
    getSamplePolandIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SamplePoland', 'samplePolandId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSampleStatusId(val){
        this.sampleStatusId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSampleStatusIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SampleStatusFashion', 'sampleStatusId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSampleStatusIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SampleStatusFashion', 'sampleStatusId'); //  true 
    }

        /** @returns {Promise<SampleStatusFashion>} */
    getSampleStatusIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SampleStatusFashion', 'sampleStatusId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSeasonId(val){
        this.seasonId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Season', 'seasonId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Season', 'seasonId'); //  true 
    }

        /** @returns {Promise<Season>} */
    getSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Season', 'seasonId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSeasonalityId(val){
        this.seasonalityId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSeasonalityIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Seasonality', 'seasonalityId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSeasonalityIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Seasonality', 'seasonalityId'); //  true 
    }

        /** @returns {Promise<Seasonality>} */
    getSeasonalityIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Seasonality', 'seasonalityId', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSelectedForCollection(val){
        this.selectedForCollection = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSessionId(val){
        this.sessionId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSessionIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Session', 'sessionId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSessionIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Session', 'sessionId'); //  true 
    }

        /** @returns {Promise<Session>} */
    getSessionIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Session', 'sessionId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withShoeHoofName(val){
        this.shoeHoofName = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getShoeHoofNameLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'shoeHoofName', allowRemote); //  true 
    }

    /** @returns {String} */
        getShoeHoofNameStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'shoeHoofName'); //  true 
    }

        /** @returns {Promise<ComponentIndex>} */
    getShoeHoofNameEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ComponentIndex', 'shoeHoofName', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withShoeHoofProducer(val){
        this.shoeHoofProducer = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getShoeHoofProducerLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'shoeHoofProducer', allowRemote); //  true 
    }

    /** @returns {String} */
        getShoeHoofProducerStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'shoeHoofProducer'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getShoeHoofProducerEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'shoeHoofProducer', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withShoeSoleName(val){
        this.shoeSoleName = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getShoeSoleNameLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'shoeSoleName', allowRemote); //  true 
    }

    /** @returns {String} */
        getShoeSoleNameStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'shoeSoleName'); //  true 
    }

        /** @returns {Promise<ComponentIndex>} */
    getShoeSoleNameEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ComponentIndex', 'shoeSoleName', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withShoeStiffness(val){
        this.shoeStiffness = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getShoeStiffnessLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ShoeStiffness', 'shoeStiffness', allowRemote); //  true 
    }

    /** @returns {String} */
        getShoeStiffnessStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ShoeStiffness', 'shoeStiffness'); //  true 
    }

        /** @returns {Promise<ShoeStiffness>} */
    getShoeStiffnessEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ShoeStiffness', 'shoeStiffness', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withShortcutModel(val){
        this.shortcutModel = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withShouldUpgradeOrderNumberSequence(val){
        this.shouldUpgradeOrderNumberSequence = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withShouldUpgradeSKUSequence(val){
        this.shouldUpgradeSKUSequence = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSizeGroupId(val){
        this.sizeGroupId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSizeGroupIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SizeGroup', 'sizeGroupId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSizeGroupIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SizeGroup', 'sizeGroupId'); //  true 
    }

        /** @returns {Promise<SizeGroup>} */
    getSizeGroupIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SizeGroup', 'sizeGroupId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSizeRange(val){
        this.sizeRange = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSizeRangeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SizeRanges', 'sizeRange', allowRemote); //  true 
    }

    /** @returns {String} */
        getSizeRangeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SizeRanges', 'sizeRange'); //  true 
    }

        /** @returns {Promise<SizeRanges>} */
    getSizeRangeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SizeRanges', 'sizeRange', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSizesConfirmed(val){
        this.sizesConfirmed = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSmallAndLargeSizesId(val){
        this.smallAndLargeSizesId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSmallAndLargeSizesIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SmallAndLargeSize', 'smallAndLargeSizesId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSmallAndLargeSizesIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SmallAndLargeSize', 'smallAndLargeSizesId'); //  true 
    }

        /** @returns {Promise<SmallAndLargeSize>} */
    getSmallAndLargeSizesIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SmallAndLargeSize', 'smallAndLargeSizesId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withStateOfPrestaShopIntegration(val){
        this.stateOfPrestaShopIntegration = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getStateOfPrestaShopIntegrationLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.IntegrationStatuses', 'stateOfPrestaShopIntegration', allowRemote); //  true 
    }

    /** @returns {String} */
        getStateOfPrestaShopIntegrationStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.IntegrationStatuses', 'stateOfPrestaShopIntegration'); //  true 
    }

        /** @returns {Promise<IntegrationStatuses>} */
    getStateOfPrestaShopIntegrationEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.IntegrationStatuses', 'stateOfPrestaShopIntegration', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withStyleCut(val){
        this.styleCut = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getStyleCutLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.StyleCut', 'styleCut', allowRemote); //  true 
    }

    /** @returns {String} */
        getStyleCutStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.StyleCut', 'styleCut'); //  true 
    }

        /** @returns {Promise<StyleCut>} */
    getStyleCutEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.StyleCut', 'styleCut', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSubSeasonId(val){
        this.subSeasonId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSubSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.SubSeason', 'subSeasonId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSubSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.SubSeason', 'subSeasonId'); //  true 
    }

        /** @returns {Promise<SubSeason>} */
    getSubSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.SubSeason', 'subSeasonId', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSuggestedPrice(val){
        this.suggestedPrice = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSupplierFinalOffer(val){
        this.supplierFinalOffer = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSupplierFinalOfferLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'supplierFinalOffer', allowRemote); //  true 
    }

    /** @returns {String} */
        getSupplierFinalOfferStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'supplierFinalOffer'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getSupplierFinalOfferEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'supplierFinalOffer', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSupplierId(val){
        this.supplierId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'supplierId'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withSupplierProductId(val){
        this.supplierProductId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withTechnologicalComponents(val){
        this.technologicalComponents = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withTechnologistConstructor(val){
        this.technologistConstructor = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTechnologistConstructorLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'technologistConstructor', allowRemote); //  true 
    }

    /** @returns {String} */
        getTechnologistConstructorStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'technologistConstructor'); //  true 
    }

        /** @returns {Promise<ApplicationUser>} */
    getTechnologistConstructorEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'technologistConstructor', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withTechnologistProjectStatus(val){
        this.technologistProjectStatus = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTechnologistProjectStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TechnologistProjectStatus', 'technologistProjectStatus', allowRemote); //  true 
    }

    /** @returns {String} */
        getTechnologistProjectStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TechnologistProjectStatus', 'technologistProjectStatus'); //  true 
    }

        /** @returns {Promise<TechnologistProjectStatus>} */
    getTechnologistProjectStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TechnologistProjectStatus', 'technologistProjectStatus', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withTypeOfBoxId(val){
        this.typeOfBoxId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTypeOfBoxIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TypeOfBox', 'typeOfBoxId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTypeOfBoxIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TypeOfBox', 'typeOfBoxId'); //  true 
    }

        /** @returns {Promise<TypeOfBox>} */
    getTypeOfBoxIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TypeOfBox', 'typeOfBoxId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withTypeOfFootwearId(val){
        this.typeOfFootwearId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTypeOfFootwearIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TypeOfFootwear', 'typeOfFootwearId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTypeOfFootwearIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TypeOfFootwear', 'typeOfFootwearId'); //  true 
    }

        /** @returns {Promise<TypeOfFootwear>} */
    getTypeOfFootwearIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TypeOfFootwear', 'typeOfFootwearId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withTypeOfNumberingId(val){
        this.typeOfNumberingId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTypeOfNumberingIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TypeOfNumbering', 'typeOfNumberingId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTypeOfNumberingIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TypeOfNumbering', 'typeOfNumberingId'); //  true 
    }

        /** @returns {Promise<TypeOfNumbering>} */
    getTypeOfNumberingIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TypeOfNumbering', 'typeOfNumberingId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withTypeOfOfferId(val){
        this.typeOfOfferId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTypeOfOfferIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TypeOfOffer', 'typeOfOfferId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTypeOfOfferIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TypeOfOffer', 'typeOfOfferId'); //  true 
    }

        /** @returns {Promise<TypeOfOffer>} */
    getTypeOfOfferIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TypeOfOffer', 'typeOfOfferId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withTypeOfSoleId(val){
        this.typeOfSoleId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTypeOfSoleIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TypeOfSole', 'typeOfSoleId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTypeOfSoleIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TypeOfSole', 'typeOfSoleId'); //  true 
    }

        /** @returns {Promise<TypeOfSole>} */
    getTypeOfSoleIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TypeOfSole', 'typeOfSoleId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withTypeUpperWidth(val){
        this.typeUpperWidth = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTypeUpperWidthLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TypeUpperWidth', 'typeUpperWidth', allowRemote); //  true 
    }

    /** @returns {String} */
        getTypeUpperWidthStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TypeUpperWidth', 'typeUpperWidth'); //  true 
    }

        /** @returns {Promise<TypeUpperWidth>} */
    getTypeUpperWidthEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TypeUpperWidth', 'typeUpperWidth', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withUnit(val){
        this.unit = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getUnitLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Unit', 'unit', allowRemote); //  true 
    }

    /** @returns {String} */
        getUnitStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Unit', 'unit'); //  true 
    }

        /** @returns {Promise<Unit>} */
    getUnitEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Unit', 'unit', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withUpperCircumference(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.upperCircumference = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withUpperHeight(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.upperHeight = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withUuid(val){
        this.uuid = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withVersion(val){
        this.version = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withWarmingId(val){
        this.warmingId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getWarmingIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Warming', 'warmingId', allowRemote); //  true 
    }

    /** @returns {String} */
        getWarmingIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Warming', 'warmingId'); //  true 
    }

        /** @returns {Promise<Warming>} */
    getWarmingIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Warming', 'warmingId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason}
     */
    withWeight(val){
        this.weight = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<ProductInSeason>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadProductInSeason(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'ERPProductWarehouse'){
            return this.getERPProductWarehouseLabel(allowRemote);
        }
        if(fiendName === 'PM'){
            return this.getPMLabel(allowRemote);
        }
        if(fiendName === 'VATRate'){
            return this.getVATRateLabel(allowRemote);
        }
        if(fiendName === 'approvalStatus'){
            return this.getApprovalStatusLabel(allowRemote);
        }
        if(fiendName === 'assemblySystemId'){
            return this.getAssemblySystemIdLabel(allowRemote);
        }
        if(fiendName === 'assortmentGroupId'){
            return this.getAssortmentGroupIdLabel(allowRemote);
        }
        if(fiendName === 'basicOfferId'){
            return this.getBasicOfferIdLabel(allowRemote);
        }
        if(fiendName === 'brand'){
            return this.getBrandLabel(allowRemote);
        }
        if(fiendName === 'capsuleName'){
            return this.getCapsuleNameLabel(allowRemote);
        }
        if(fiendName === 'category'){
            return this.getCategoryLabel(allowRemote);
        }
        if(fiendName === 'clientId'){
            return this.getClientIdLabel(allowRemote);
        }
        if(fiendName === 'cnCodeId'){
            return this.getCnCodeIdLabel(allowRemote);
        }
        if(fiendName === 'collection'){
            return this.getCollectionLabel(allowRemote);
        }
        if(fiendName === 'collectionDirector'){
            return this.getCollectionDirectorLabel(allowRemote);
        }
        if(fiendName === 'colorId'){
            return this.getColorIdLabel(allowRemote);
        }
        if(fiendName === 'commissionId'){
            return this.getCommissionIdLabel(allowRemote);
        }
        if(fiendName === 'commodityGroupId'){
            return this.getCommodityGroupIdLabel(allowRemote);
        }
        if(fiendName === 'compositionId'){
            return this.getCompositionIdLabel(allowRemote);
        }
        if(fiendName === 'countryOfOrigin'){
            return this.getCountryOfOriginLabel(allowRemote);
        }
        if(fiendName === 'departmentId'){
            return this.getDepartmentIdLabel(allowRemote);
        }
        if(fiendName === 'designer'){
            return this.getDesignerLabel(allowRemote);
        }
        if(fiendName === 'designerProjectStatus'){
            return this.getDesignerProjectStatusLabel(allowRemote);
        }
        if(fiendName === 'dimensionId'){
            return this.getDimensionIdLabel(allowRemote);
        }
        if(fiendName === 'fabricSupplier'){
            return this.getFabricSupplierLabel(allowRemote);
        }
        if(fiendName === 'formNumberId'){
            return this.getFormNumberIdLabel(allowRemote);
        }
        if(fiendName === 'graphicDesigner'){
            return this.getGraphicDesignerLabel(allowRemote);
        }
        if(fiendName === 'graphicDesignerProjectStatus'){
            return this.getGraphicDesignerProjectStatusLabel(allowRemote);
        }
        if(fiendName === 'heelColor'){
            return this.getHeelColorLabel(allowRemote);
        }
        if(fiendName === 'heelName'){
            return this.getHeelNameLabel(allowRemote);
        }
        if(fiendName === 'heelProducer'){
            return this.getHeelProducerLabel(allowRemote);
        }
        if(fiendName === 'heelTypeId'){
            return this.getHeelTypeIdLabel(allowRemote);
        }
        if(fiendName === 'leatherColor'){
            return this.getLeatherColorLabel(allowRemote);
        }
        if(fiendName === 'leatherId'){
            return this.getLeatherIdLabel(allowRemote);
        }
        if(fiendName === 'leatherName'){
            return this.getLeatherNameLabel(allowRemote);
        }
        if(fiendName === 'leatherProducer'){
            return this.getLeatherProducerLabel(allowRemote);
        }
        if(fiendName === 'line'){
            return this.getLineLabel(allowRemote);
        }
        if(fiendName === 'lineId'){
            return this.getLineIdLabel(allowRemote);
        }
        if(fiendName === 'mainGroupId'){
            return this.getMainGroupIdLabel(allowRemote);
        }
        if(fiendName === 'nameTransferredToIntrastatDeclarationId'){
            return this.getNameTransferredToIntrastatDeclarationIdLabel(allowRemote);
        }
        if(fiendName === 'nextSeasonCollectionId'){
            return this.getNextSeasonCollectionIdLabel(allowRemote);
        }
        if(fiendName === 'nextSeasonTypeOfOfferId'){
            return this.getNextSeasonTypeOfOfferIdLabel(allowRemote);
        }
        if(fiendName === 'path'){
            return this.getPathLabel(allowRemote);
        }
        if(fiendName === 'pattern'){
            return this.getPatternLabel(allowRemote);
        }
        if(fiendName === 'preferredConstructor'){
            return this.getPreferredConstructorLabel(allowRemote);
        }
        if(fiendName === 'preferredDesigner'){
            return this.getPreferredDesignerLabel(allowRemote);
        }
        if(fiendName === 'productId'){
            return this.getProductIdLabel(allowRemote);
        }
        if(fiendName === 'productType'){
            return this.getProductTypeLabel(allowRemote);
        }
        if(fiendName === 'salesCategory'){
            return this.getSalesCategoryLabel(allowRemote);
        }
        if(fiendName === 'salesChannelId'){
            return this.getSalesChannelIdLabel(allowRemote);
        }
        if(fiendName === 'samplePolandId'){
            return this.getSamplePolandIdLabel(allowRemote);
        }
        if(fiendName === 'sampleStatusId'){
            return this.getSampleStatusIdLabel(allowRemote);
        }
        if(fiendName === 'seasonId'){
            return this.getSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'seasonalityId'){
            return this.getSeasonalityIdLabel(allowRemote);
        }
        if(fiendName === 'sessionId'){
            return this.getSessionIdLabel(allowRemote);
        }
        if(fiendName === 'shoeHoofName'){
            return this.getShoeHoofNameLabel(allowRemote);
        }
        if(fiendName === 'shoeHoofProducer'){
            return this.getShoeHoofProducerLabel(allowRemote);
        }
        if(fiendName === 'shoeSoleName'){
            return this.getShoeSoleNameLabel(allowRemote);
        }
        if(fiendName === 'shoeStiffness'){
            return this.getShoeStiffnessLabel(allowRemote);
        }
        if(fiendName === 'sizeGroupId'){
            return this.getSizeGroupIdLabel(allowRemote);
        }
        if(fiendName === 'sizeRange'){
            return this.getSizeRangeLabel(allowRemote);
        }
        if(fiendName === 'smallAndLargeSizesId'){
            return this.getSmallAndLargeSizesIdLabel(allowRemote);
        }
        if(fiendName === 'stateOfPrestaShopIntegration'){
            return this.getStateOfPrestaShopIntegrationLabel(allowRemote);
        }
        if(fiendName === 'styleCut'){
            return this.getStyleCutLabel(allowRemote);
        }
        if(fiendName === 'subSeasonId'){
            return this.getSubSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'supplierFinalOffer'){
            return this.getSupplierFinalOfferLabel(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdLabel(allowRemote);
        }
        if(fiendName === 'technologistConstructor'){
            return this.getTechnologistConstructorLabel(allowRemote);
        }
        if(fiendName === 'technologistProjectStatus'){
            return this.getTechnologistProjectStatusLabel(allowRemote);
        }
        if(fiendName === 'typeOfBoxId'){
            return this.getTypeOfBoxIdLabel(allowRemote);
        }
        if(fiendName === 'typeOfFootwearId'){
            return this.getTypeOfFootwearIdLabel(allowRemote);
        }
        if(fiendName === 'typeOfNumberingId'){
            return this.getTypeOfNumberingIdLabel(allowRemote);
        }
        if(fiendName === 'typeOfOfferId'){
            return this.getTypeOfOfferIdLabel(allowRemote);
        }
        if(fiendName === 'typeOfSoleId'){
            return this.getTypeOfSoleIdLabel(allowRemote);
        }
        if(fiendName === 'typeUpperWidth'){
            return this.getTypeUpperWidthLabel(allowRemote);
        }
        if(fiendName === 'unit'){
            return this.getUnitLabel(allowRemote);
        }
        if(fiendName === 'warmingId'){
            return this.getWarmingIdLabel(allowRemote);
        }
        if(fiendName === 'computeDesignerProjectStatus'){
            return this.getComputeDesignerProjectStatusLabel(allowRemote);
        }
        if(fiendName === 'computeGraphicDesignerProjectStatus'){
            return this.getComputeGraphicDesignerProjectStatusLabel(allowRemote);
        }
        if(fiendName === 'computeTechnologistProjectStatus'){
            return this.getComputeTechnologistProjectStatusLabel(allowRemote);
        }
        if(fiendName === 'computedProductType'){
            return this.getComputedProductTypeLabel(allowRemote);
        }
        if(fiendName === 'computedVATFromCalculation'){
            return this.getComputedVATFromCalculationLabel(allowRemote);
        }
        if(fiendName === 'countryOfOriginFinalOffer'){
            return this.getCountryOfOriginFinalOfferLabel(allowRemote);
        }
        if(fiendName === 'port'){
            return this.getPortLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'ERPProductWarehouse'){
            return this.getERPProductWarehouseEntity(allowRemote);
        }
        if(fiendName === 'PM'){
            return this.getPMEntity(allowRemote);
        }
        if(fiendName === 'VATRate'){
            return this.getVATRateEntity(allowRemote);
        }
        if(fiendName === 'approvalStatus'){
            return this.getApprovalStatusEntity(allowRemote);
        }
        if(fiendName === 'assemblySystemId'){
            return this.getAssemblySystemIdEntity(allowRemote);
        }
        if(fiendName === 'assortmentGroupId'){
            return this.getAssortmentGroupIdEntity(allowRemote);
        }
        if(fiendName === 'basicOfferId'){
            return this.getBasicOfferIdEntity(allowRemote);
        }
        if(fiendName === 'brand'){
            return this.getBrandEntity(allowRemote);
        }
        if(fiendName === 'capsuleName'){
            return this.getCapsuleNameEntity(allowRemote);
        }
        if(fiendName === 'category'){
            return this.getCategoryEntity(allowRemote);
        }
        if(fiendName === 'clientId'){
            return this.getClientIdEntity(allowRemote);
        }
        if(fiendName === 'cnCodeId'){
            return this.getCnCodeIdEntity(allowRemote);
        }
        if(fiendName === 'collection'){
            return this.getCollectionEntity(allowRemote);
        }
        if(fiendName === 'collectionDirector'){
            return this.getCollectionDirectorEntity(allowRemote);
        }
        if(fiendName === 'colorId'){
            return this.getColorIdEntity(allowRemote);
        }
        if(fiendName === 'commissionId'){
            return this.getCommissionIdEntity(allowRemote);
        }
        if(fiendName === 'commodityGroupId'){
            return this.getCommodityGroupIdEntity(allowRemote);
        }
        if(fiendName === 'compositionId'){
            return this.getCompositionIdEntity(allowRemote);
        }
        if(fiendName === 'countryOfOrigin'){
            return this.getCountryOfOriginEntity(allowRemote);
        }
        if(fiendName === 'departmentId'){
            return this.getDepartmentIdEntity(allowRemote);
        }
        if(fiendName === 'designer'){
            return this.getDesignerEntity(allowRemote);
        }
        if(fiendName === 'designerProjectStatus'){
            return this.getDesignerProjectStatusEntity(allowRemote);
        }
        if(fiendName === 'dimensionId'){
            return this.getDimensionIdEntity(allowRemote);
        }
        if(fiendName === 'fabricSupplier'){
            return this.getFabricSupplierEntity(allowRemote);
        }
        if(fiendName === 'formNumberId'){
            return this.getFormNumberIdEntity(allowRemote);
        }
        if(fiendName === 'graphicDesigner'){
            return this.getGraphicDesignerEntity(allowRemote);
        }
        if(fiendName === 'graphicDesignerProjectStatus'){
            return this.getGraphicDesignerProjectStatusEntity(allowRemote);
        }
        if(fiendName === 'heelColor'){
            return this.getHeelColorEntity(allowRemote);
        }
        if(fiendName === 'heelName'){
            return this.getHeelNameEntity(allowRemote);
        }
        if(fiendName === 'heelProducer'){
            return this.getHeelProducerEntity(allowRemote);
        }
        if(fiendName === 'heelTypeId'){
            return this.getHeelTypeIdEntity(allowRemote);
        }
        if(fiendName === 'leatherColor'){
            return this.getLeatherColorEntity(allowRemote);
        }
        if(fiendName === 'leatherId'){
            return this.getLeatherIdEntity(allowRemote);
        }
        if(fiendName === 'leatherName'){
            return this.getLeatherNameEntity(allowRemote);
        }
        if(fiendName === 'leatherProducer'){
            return this.getLeatherProducerEntity(allowRemote);
        }
        if(fiendName === 'line'){
            return this.getLineEntity(allowRemote);
        }
        if(fiendName === 'lineId'){
            return this.getLineIdEntity(allowRemote);
        }
        if(fiendName === 'mainGroupId'){
            return this.getMainGroupIdEntity(allowRemote);
        }
        if(fiendName === 'nameTransferredToIntrastatDeclarationId'){
            return this.getNameTransferredToIntrastatDeclarationIdEntity(allowRemote);
        }
        if(fiendName === 'nextSeasonCollectionId'){
            return this.getNextSeasonCollectionIdEntity(allowRemote);
        }
        if(fiendName === 'nextSeasonTypeOfOfferId'){
            return this.getNextSeasonTypeOfOfferIdEntity(allowRemote);
        }
        if(fiendName === 'path'){
            return this.getPathEntity(allowRemote);
        }
        if(fiendName === 'pattern'){
            return this.getPatternEntity(allowRemote);
        }
        if(fiendName === 'preferredConstructor'){
            return this.getPreferredConstructorEntity(allowRemote);
        }
        if(fiendName === 'preferredDesigner'){
            return this.getPreferredDesignerEntity(allowRemote);
        }
        if(fiendName === 'productId'){
            return this.getProductIdEntity(allowRemote);
        }
        if(fiendName === 'productType'){
            return this.getProductTypeEntity(allowRemote);
        }
        if(fiendName === 'salesCategory'){
            return this.getSalesCategoryEntity(allowRemote);
        }
        if(fiendName === 'salesChannelId'){
            return this.getSalesChannelIdEntity(allowRemote);
        }
        if(fiendName === 'samplePolandId'){
            return this.getSamplePolandIdEntity(allowRemote);
        }
        if(fiendName === 'sampleStatusId'){
            return this.getSampleStatusIdEntity(allowRemote);
        }
        if(fiendName === 'seasonId'){
            return this.getSeasonIdEntity(allowRemote);
        }
        if(fiendName === 'seasonalityId'){
            return this.getSeasonalityIdEntity(allowRemote);
        }
        if(fiendName === 'sessionId'){
            return this.getSessionIdEntity(allowRemote);
        }
        if(fiendName === 'shoeHoofName'){
            return this.getShoeHoofNameEntity(allowRemote);
        }
        if(fiendName === 'shoeHoofProducer'){
            return this.getShoeHoofProducerEntity(allowRemote);
        }
        if(fiendName === 'shoeSoleName'){
            return this.getShoeSoleNameEntity(allowRemote);
        }
        if(fiendName === 'shoeStiffness'){
            return this.getShoeStiffnessEntity(allowRemote);
        }
        if(fiendName === 'sizeGroupId'){
            return this.getSizeGroupIdEntity(allowRemote);
        }
        if(fiendName === 'sizeRange'){
            return this.getSizeRangeEntity(allowRemote);
        }
        if(fiendName === 'smallAndLargeSizesId'){
            return this.getSmallAndLargeSizesIdEntity(allowRemote);
        }
        if(fiendName === 'stateOfPrestaShopIntegration'){
            return this.getStateOfPrestaShopIntegrationEntity(allowRemote);
        }
        if(fiendName === 'styleCut'){
            return this.getStyleCutEntity(allowRemote);
        }
        if(fiendName === 'subSeasonId'){
            return this.getSubSeasonIdEntity(allowRemote);
        }
        if(fiendName === 'supplierFinalOffer'){
            return this.getSupplierFinalOfferEntity(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdEntity(allowRemote);
        }
        if(fiendName === 'technologistConstructor'){
            return this.getTechnologistConstructorEntity(allowRemote);
        }
        if(fiendName === 'technologistProjectStatus'){
            return this.getTechnologistProjectStatusEntity(allowRemote);
        }
        if(fiendName === 'typeOfBoxId'){
            return this.getTypeOfBoxIdEntity(allowRemote);
        }
        if(fiendName === 'typeOfFootwearId'){
            return this.getTypeOfFootwearIdEntity(allowRemote);
        }
        if(fiendName === 'typeOfNumberingId'){
            return this.getTypeOfNumberingIdEntity(allowRemote);
        }
        if(fiendName === 'typeOfOfferId'){
            return this.getTypeOfOfferIdEntity(allowRemote);
        }
        if(fiendName === 'typeOfSoleId'){
            return this.getTypeOfSoleIdEntity(allowRemote);
        }
        if(fiendName === 'typeUpperWidth'){
            return this.getTypeUpperWidthEntity(allowRemote);
        }
        if(fiendName === 'unit'){
            return this.getUnitEntity(allowRemote);
        }
        if(fiendName === 'warmingId'){
            return this.getWarmingIdEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<ProductInSeason>}
 */
async function loadProductInSeason(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<ProductInSeason[]>}
 */
async function listProductInSeason(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelProductInSeason(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<ProductInSeason>}
 */
ProductInSeason.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<ProductInSeason[]>}
 */
ProductInSeason.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<ProductInSeason[]>}
 */
ProductInSeason.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<ProductInSeason[]>}
 */
ProductInSeason.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<ProductInSeason>}
 */
ProductInSeason.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return ProductInSeason.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
ProductInSeason.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
ProductInSeason.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
ProductInSeason.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
ProductInSeason.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
ProductInSeason.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['DateOfCompletionOfTheOrderForTheReferenceModel'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['ERPProductWarehouse'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['HSCode'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['PM'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['SKUNumber'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['VATRate'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['aiInsight'] = {'remoteType' : 'com.fasterxml.jackson.databind.node.ObjectNode', 'jsType' : 'Object', 'mapped' : 'true'};
metadata['aiInsightInProgress'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['approvalStatus'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['assemblySystemId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['assortmentGroupId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['basicOfferId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['brand'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['capacity'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['capsuleName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['category'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['changeOnlyHeelName'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['changeOnlyLeatherName'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['changeOnlyShoeHoofName'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['clientId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['cnCodeId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['collection'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['collectionDirector'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorBox'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['colorId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['commissionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['commodityGroupId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['compositionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['continuation'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['countryOfOrigin'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dateOfDeliveryOfTheReferenceModel'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['dateOfTransferOfTheOrder'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['departmentId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['description'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['designer'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['designerProjectStatus'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['detailsName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dimensionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['endDateDesigner'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['endDateGraphicDesigner'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['endDateTechnologist'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['englishName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fabricCodeCoupon'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fabricSupplier'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['formNumberId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['gallery'] = {'remoteType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'jsType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'mapped' : 'false'};
metadata['graphicDesigner'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['graphicDesignerProjectStatus'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['heelColor'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['heelName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['heelProducer'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['heelTypeId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['initialPrice'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['isATargetDesign'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['leatherColor'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['leatherId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['leatherName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['leatherProducer'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['line'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['lineId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['mainGroupId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['marketingName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['merchants'] = {'remoteType' : 'module:src/server/com/silkplm/model/plm/ApplicationUserOnProductInSeasonEmbedded.ApplicationUserOnProductInSeasonEmbedded[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/ApplicationUserOnProductInSeasonEmbedded.ApplicationUserOnProductInSeasonEmbedded[]', 'mapped' : 'false'};
metadata['multicolor'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['name'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['nameTransferredToIntrastatDeclarationId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['nextSeasonCollectionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['nextSeasonTypeOfOfferId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['notes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['notesRelatedToFirstPPSample'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['numberOfProduct'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['orderNumber'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['outletPrice'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['path'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['pattern'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['patternShoes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['plannedDeliveryDateStores'] = {'remoteType' : 'module:src/server/com/silkplm/model/plm/DeliveryDateStore.DeliveryDateStore[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/DeliveryDateStore.DeliveryDateStore[]', 'mapped' : 'false'};
metadata['preferredConstructor'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['preferredDesigner'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['print'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['processing'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['productCategoryAttributes'] = {'remoteType' : 'module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]', 'mapped' : 'false'};
metadata['productFeatures'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['promotionalPrice'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['relatedModels'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['retailPrice'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['salesCategory'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['salesChannelId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['sampleNo'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['samplePolandId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['sampleStatusId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['seasonId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['seasonalityId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['selectedForCollection'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['sessionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shoeHoofName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shoeHoofProducer'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shoeSoleName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shoeStiffness'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shortcutModel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shouldUpgradeOrderNumberSequence'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['shouldUpgradeSKUSequence'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['sizeGroupId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['sizeRange'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['sizesConfirmed'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['smallAndLargeSizesId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['stateOfPrestaShopIntegration'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['styleCut'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['subSeasonId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['suggestedPrice'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['supplierFinalOffer'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierProductId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['technologicalComponents'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['technologistConstructor'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['technologistProjectStatus'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['typeOfBoxId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['typeOfFootwearId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['typeOfNumberingId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['typeOfOfferId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['typeOfSoleId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['typeUpperWidth'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['unit'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['upperCircumference'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['upperHeight'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['uuid'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['warmingId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['weight'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['approvalToCollection'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['calculateShortcutModels'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['colorWarning'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['computeDesignerProjectStatus'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['computeGraphicDesignerProjectStatus'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['computeTechnologistProjectStatus'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['computedFullName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['computedProductType'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['computedVATFromCalculation'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['countryOfOriginFinalOffer'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['defaultEAN'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['eAN'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['finalDecision'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['finalPurchasingPriceFinalOffer'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['firstMargin'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['fullName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['margin'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['marginFinalOffer'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['merchantsComputed'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['minQuantityFinalOffer'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['nameFromERP'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['netPrice'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['port'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['priceGroup'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['productInStores'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['productInStoresMonth'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['productInWarehouse'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['productInWarehouseWeek'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['productionCostFinalOffer'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['seasonWarning'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['stockLevels'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['targetPlanningProduct'] = {'computed' : true, 'remoteType' : '*[]', 'jsType' : '*[]', 'mapped' : 'false'};
metadata['todayDate'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['typeOrKind'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['whatsNext'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['lineDeadlineForDeliveryOfFabric'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['lineDeadlineForDeliveryToWarehouse'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['lineDeadlineForDispatch'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['lineDeadlineForFabricOrder'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['lineDeadlineForPrototype'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['lineDeadlineForTheContractOfTheFinishedProduct'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['lineDeadlineOfEntryOfEntireLineIntoShops'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['lineDesignDeadline'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['seasonIdFirstReleaseDate'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['linePlanDeadline'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['seasonIdReleaseDate'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['fabricSupplierSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierFinalOfferSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierIdSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.ProductInSeason';
metadata.__type_short__ = 'ProductInSeason';
ProductInSeason.prototype.__metadata__ = metadata;

ProductInSeason.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/ProductInSeason */
export default ProductInSeason

export { ProductInSeason , loadProductInSeason, listProductInSeason, labelProductInSeason }
